var generateEVMDeepLink = function (tokenAddress, chainId, recipientAddress, amountUnits) {
    return "ethereum:".concat(tokenAddress, "@").concat(chainId, "/transfer?address=").concat(recipientAddress, "&uint256=").concat(amountUnits);
};
export { generateEVMDeepLink };
